var modules_8bb178ca = {"container":"ThemeSwitcher_module_container__7fd80937","iconWrapper":"ThemeSwitcher_module_iconWrapper__7fd80937","icon":"ThemeSwitcher_module_icon__7fd80937","bounceIn":"ThemeSwitcher_module_bounceIn__7fd80937","bounce-in":"ThemeSwitcher_module_bounceIn__7fd80937","bounceOut":"ThemeSwitcher_module_bounceOut__7fd80937","bounce-out":"ThemeSwitcher_module_bounceOut__7fd80937"};
import "../../../assets/CezwDW88.css";

export { modules_8bb178ca as default };
//# sourceMappingURL=ThemeSwitcher.module.less.js.map
